import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = _resolveComponent("Input")
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["reference", {invalid: !$data.valid, underline: $props.underline}]),
    style: _normalizeStyle({'--text': _ctx.value})
  }, [
    _createVNode(_component_Input, {
      ref: "input",
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
      "vread-from": "valid",
      "onUpdate:valid": $event => (($data.valid) = $event),
      required: $props.required,
      regexp: $props.regexp,
      type: $props.type,
      spellcheck: false,
      maxlength: $props.maxlength,
      class: "text",
      readonly: $props.readonly,
      footer: false,
      placeholder: $props.placeholder
    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:valid", "required", "regexp", "type", "maxlength", "readonly", "placeholder"]),
    (_ctx.$slots.icon)
      ? _renderSlot(_ctx.$slots, "icon", { key: 0 }, undefined, true)
      : (_openBlock(), _createBlock(_component_Icon, {
          key: 1,
          icon: $props.icon,
          size: "1.6rem",
          stroke: "var(--brand-700)",
          "stroke-width": "1"
        }, null, 8 /* PROPS */, ["icon"]))
  ], 6 /* CLASS, STYLE */))
}